import { createContext, use } from "react";

import invariant from "tiny-invariant";

import type { User } from "shared/api/use-auth-login-query";

type AuthContextType = {
  user: User;
  token: string;
};

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);

export const useAuthData = () => {
  const ctx = use(AuthContext);
  invariant(ctx, "useAuthData must be used within AuthContext.Provider");

  return ctx;
};
